export const get_route_language = (languageValue) => {
    const normalizedLanguage = `${languageValue || ''}`.trim().toLowerCase();

    if (!normalizedLanguage.length) {
        return 'en';
    }

    const languagePrefix = normalizedLanguage.split('-')[0].split('_')[0];

    if (!languagePrefix.length) {
        return 'en';
    }

    return languagePrefix;
};
